import { RepositoryIdValue } from 'yeself-common/typings/addons/assetAddon/AssetAddonCommon';
import { ApplicationId } from 'yeself-common/typings/application/Application';
import { LayerId } from 'yeself-common/typings/guide/LayerCommon';
import { AddonSystemKeyValue, AssetId } from 'yeself-common/typings/guide/recording/Recording';

import {
    FETCH_RECORDING_OUTPUTS_REQUEST,
    FETCH_RECORDING_OUTPUTS_SUCCESS,
    FETCH_RECORDING_OUTPUTS_FAIL,
    GENERATE_RECORDING_OUTPUTS_REQUEST,
    GENERATE_RECORDING_OUTPUTS_SUCCESS,
    GENERATE_RECORDING_OUTPUTS_FAIL,
    RecordingActionTypes,
} from './types';

export const fetchRecordingOutputsRequest = (
    applicationId: ApplicationId,
    guideId: LayerId,
    assetId: AssetId,
    addonSystemKey: AddonSystemKeyValue,
    repositoryId: RepositoryIdValue,
    message: Record<string, JSX.Element>
): RecordingActionTypes => ({
    type: FETCH_RECORDING_OUTPUTS_REQUEST,
    payload: { applicationId, guideId, assetId, addonSystemKey, repositoryId, message },
});

export const fetchRecordingOutputsSuccess = (
    guideId,
    assetId,
    addonSystemKey,
    repositoryId,
    message
) => ({
    type: FETCH_RECORDING_OUTPUTS_SUCCESS,
    payload: { guideId, assetId, addonSystemKey, repositoryId, message },
});

export const fetchRecordingOutputsFail = () => ({
    type: FETCH_RECORDING_OUTPUTS_FAIL,
});

export const generateRecordingOutputsRequest = (guideId, message) => ({
    type: GENERATE_RECORDING_OUTPUTS_REQUEST,
    payload: { guideId, message },
});

export const generateRecordingOutputsSuccess = (guideId, message) => ({
    type: GENERATE_RECORDING_OUTPUTS_SUCCESS,
    payload: { guideId, message },
});

export const generateRecordingOutputsFail = () => ({
    type: GENERATE_RECORDING_OUTPUTS_FAIL,
});
